import { createSelector } from '@reduxjs/toolkit';
import { defaultUnits, QuantitiesTypes } from 'src/enums/unit-templates.ts';
import type { TRootState } from 'src/store/store-types';

export const selectTemplates = (entities: TRootState['entities']) => entities.unitTemplates;

export const selectUnitByQuantity = createSelector(
  [selectTemplates, (_: TRootState['entities'], quantity: QuantitiesTypes) => quantity],
  (unitTemplates, quantity) =>
    unitTemplates.activeTemplate?.configuration?.find((config) => config.quantity === quantity)?.unit ||
    defaultUnits.get(quantity),
);
